import React, { useEffect, useState } from 'react';
import { Box } from 'glints-aries';
import Markdown from 'react-markdown';
import { useSelector } from 'react-redux';

import { CountryCodes } from 'src/common/enums';
import { useConfig } from 'src/common/hooks';
import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';
import { getCountryWithSGFallback } from 'src/modules/ClientConfig/Selectors';
import * as S from 'src/modules/Terms/TermsPage.sc';

const meta = {
  title: 'Privacy Policy',
};

export const PrivacyPolicy = () => {
  const [markdownTerms, setMarkdownTerms] = useState();
  const { LANG } = useConfig();
  const COUNTRY = useSelector(getCountryWithSGFallback);

  useEffect(() => {
    // privacyPolicyLang is a workaround for Global website. Can be removed
    // when the changes mentioned here land on staging https://applink.larksuite.com/client/message/link/open?token=AmfX0N9lQgAmaieznhLpzts%3D
    const privacyPolicyLang =
      COUNTRY === CountryCodes.SG && LANG === 'en'
        ? 'en-sg'
        : LANG.toLowerCase();

    import(`./policy/${COUNTRY}/${privacyPolicyLang}.md`)
      .then((module) => {
        setMarkdownTerms(module.default);
      })
      .catch(() => {
        console.error(
          `Privacy policy not found for ${COUNTRY} for language ${privacyPolicyLang}`
        );
      });
  }, [LANG, COUNTRY]);

  return (
    <S.TermsPageContainer>
      <Box pt={24}>
        <MetadataRenderer {...meta} glintsTrackingName="privacy_policy" />
        <S.MarkdownGlintsContainer>
          <Markdown>{markdownTerms}</Markdown>
        </S.MarkdownGlintsContainer>
      </Box>
    </S.TermsPageContainer>
  );
};
